import {HttpException} from "./http.exception.js";

/**
 * 403 Forbidden Exception
 */
export class ForbiddenException extends HttpException {
    constructor(message: string = "Forbidden", errorBody?: unknown, cause?: Error) {
        super(403, message, errorBody, cause);
    }
}
